import React, { useCallback } from "react";
import { Box, Button, FormControl, FormLabel, TextField } from "@material-ui/core";

import InputDatePicker from "../../../../components/InputDatePicker";
import { useFormik } from "formik";

//format date
import UploadfileImage from "../../../../components/UploadfileImage";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";

import TextEditor from "../../../../components/TextEditor";
import { packagePromotionSchema, stylesUse } from "../helpers/formAddPackageOption";
import { uniqueId } from "lodash";

function FormAddPackage({ initialFormValues = {}, onCancel = () => {}, onSubmit = () => {}, isCreateMode = false }) {
    const classUse = stylesUse();

    // config form validate and submit
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: initialFormValues,
        validationSchema: packagePromotionSchema,
        onSubmit: onSubmit,
    });

    const handleUploadFilesThumb = (files = []) => {
        files.map(file => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = async e => {
                const name = file.name;
                await formik.setFieldValue(
                    "fileThumbs",
                    [{ id: uniqueId(), name: name, src: e.target.result, file }],
                    true,
                );
            };
            return reader;
        });
    };

    const handleUploadFilesImage = (files = []) => {
        files.map(file => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = async e => {
                const name = file.name;
                await formik.setFieldValue(
                    "fileImages",
                    [{ id: uniqueId(), name: name, src: e.target.result, file }],
                    true,
                );
            };
            return reader;
        });
    };

    const handleRemoveFilesThumb = useCallback(
        async (files = []) => {
            await formik.setFieldValue("fileThumbs", [], true);
        },
        [formik],
    );

    const handleRemoveFilesImage = useCallback(
        async (files = []) => {
            await formik.setFieldValue("fileImages", [], true);
        },
        [formik],
    );

    // onChange start date
    const handleChangeStartDate = useCallback(
        async date => {
            if (date > formik.values?.endDate) {
                await formik.setFieldValue("startDate", date, true);
                await formik.setFieldValue("endDate", date, true);
            } else {
                await formik.setFieldValue("startDate", date, true);
            }
        },
        [formik],
    );

    // onChange end date
    const handleChangeEndDate = useCallback(
        async date => {
            if (date <= formik.values?.startDate) {
                await formik.setFieldValue("startDate", date, true);
                await formik.setFieldValue("endDate", date, true);
            } else {
                await formik.setFieldValue("endDate", date, true);
            }
        },
        [formik],
    );

    // onChange text editor
    const handleChangeTextEditor = useCallback(
        async (text, field) => {
            await formik.setFieldValue(field, text, true);
        },
        [formik],
    );

    return (
        <form id="form_create_package" onSubmit={formik.handleSubmit}>
            <div className="row">
                <div className="col-12 col-xl-6 mb-3 mb-lg-5">
                    <FormControl className="t-form-group-custom" fullWidth>
                        <FormLabel className="text-dark mb-4" required>
                            Title Thai
                        </FormLabel>
                        <TextField
                            fullWidth
                            type="text"
                            name="titleTh"
                            label="Title Thai"
                            variant="outlined"
                            size="small"
                            value={formik.values?.titleTh}
                            onChange={formik.handleChange}
                            error={formik.touched?.titleTh && Boolean(formik.errors?.titleTh)}
                            helperText={formik.errors?.titleTh}
                            FormHelperTextProps={{
                                className: "text-danger",
                            }}
                        />
                    </FormControl>
                </div>
                <div className="col-12 col-xl-6 mb-3 mb-lg-5">
                    <FormControl className="t-form-group-custom" fullWidth>
                        <FormLabel className="text-dark mb-4" required>
                            Title Eng
                        </FormLabel>
                        <TextField
                            fullWidth
                            type="text"
                            name="titleEn"
                            label="Title Eng"
                            variant="outlined"
                            size="small"
                            value={formik.values?.titleEn}
                            onChange={formik.handleChange}
                            error={formik.touched?.titleEn && Boolean(formik.errors?.titleEn)}
                            helperText={formik.errors?.titleEn}
                            FormHelperTextProps={{
                                className: "text-danger",
                            }}
                        />
                    </FormControl>
                </div>
                <div className="col-12 col-xl-6 mb-3 mb-lg-5">
                    <Box className="w-100">
                        <FormLabel className="text-dark mb-4" required>
                            Date Start
                        </FormLabel>
                        <InputDatePicker
                            label=""
                            className="mt-0 t-form-group-custom"
                            value={formik.values?.startDate}
                            minDate={isCreateMode ? new Date() : null}
                            onChange={handleChangeStartDate}
                            error={formik.touched?.startDate && Boolean(formik.errors?.startDate)}
                            helperText={formik.errors?.startDate}
                            FormHelperTextProps={{
                                className: "text-danger",
                            }}
                        />
                    </Box>
                </div>
                <div className="col-12 col-xl-6 mb-3 mb-lg-5">
                    <Box className="w-100">
                        <FormLabel className="text-dark mb-4" required>
                            Date End
                        </FormLabel>
                        <InputDatePicker
                            label=""
                            className="mt-0 t-form-group-custom"
                            value={formik.values?.endDate}
                            minDate={isCreateMode ? formik.values?.startDate : null}
                            onChange={handleChangeEndDate}
                            error={formik.touched?.endDate && Boolean(formik.errors?.endDate)}
                            helperText={formik.errors?.endDate}
                            FormHelperTextProps={{
                                className: "text-danger",
                            }}
                        />
                    </Box>
                </div>
                <div className="col-12 col-lg-6 mb-3 mb-lg-5">
                    <FormLabel className="text-dark mb-4 mr-1" required>
                        Thumbnail
                    </FormLabel>
                    <FormLabel className="text-danger">(150 x 150)</FormLabel>
                    <UploadfileImage
                        previewImages={formik.values?.fileThumbs || []}
                        onAcceptedFiles={handleUploadFilesThumb}
                        removeAll={handleRemoveFilesThumb}
                        removeButton={false}
                        classImg={classUse.imageStyle}
                        error={formik.errors?.fileThumbs}
                    />
                </div>

                <div className="col-12 col-lg-6 mb-3 mb-lg-5">
                    <FormLabel className="text-dark mb-4 mr-1" required>
                        Image
                    </FormLabel>
                    <FormLabel className="text-danger">(340 x 200)</FormLabel>
                    <UploadfileImage
                        previewImages={formik.values?.fileImages || []}
                        onAcceptedFiles={handleUploadFilesImage}
                        removeAll={handleRemoveFilesImage}
                        removeButton={false}
                        classImg={classUse.imageStyleLg}
                        emptyImg={toAbsoluteUrl("/media/HCH/imgs/no-image-lg.png")}
                        error={formik.errors?.fileImages}
                    />
                </div>

                <div className="col-12 mb-3 mb-lg-5">
                    <FormLabel className="text-dark mb-4" required>
                        Content Thai
                    </FormLabel>
                    <TextEditor
                        value={formik.values?.contentTh}
                        onChange={text => handleChangeTextEditor(text, "contentTh")}
                        error={formik.errors?.contentTh}
                    />
                </div>
                <div className="col-12 mb-3 mb-lg-5">
                    <FormLabel className="text-dark mb-4" required>
                        Content Eng
                    </FormLabel>
                    <TextEditor
                        value={formik.values?.contentEn}
                        onChange={text => handleChangeTextEditor(text, "contentEn")}
                        error={formik.errors?.contentEn}
                    />
                </div>

                {/* actions */}
                <div className="col-12">
                    <Box className="row justify-content-lg-end">
                        <div className="col-6 col-lg-3">
                            <Button type="submit" className="w-100 btn t-btn-primary">
                                <i className="fas fa-save mr-1" style={{ color: "inherit" }}></i>save
                            </Button>
                        </div>
                        <div className="col-6 col-lg-3">
                            <Button type="button" onClick={onCancel} className="w-100 btn t-btn-gray">
                                cancel
                            </Button>
                        </div>
                    </Box>
                </div>
            </div>
        </form>
    );
}

export default FormAddPackage;
